@if (langOptions$ | async; as langOptions) {
  <lib-select
    class="lang-select"
    optionImgWidth="16px"
    customPanelClass="lang-options"
    [noBackground]="true"
    [withTrigger]="true"
    [dropdownIconsPath]="dropdownIconsPath"
    [options]="langOptions"
    [value]="langFormControl.value"
    (valueChange)="handleLangChange($any($event))"
  >
    @if (getLangOption(langFormControl.value, langOptions); as langOption) {
      <div>
        <div>
          <img [src]="langOption.img" /> <span>&nbsp;{{ langOption.key }}</span>
        </div>
      </div>
    }
  </lib-select>
}
